import { ApiService } from "./apiService";
import { failure } from "./serviceHelpers";
import {
  FinancialInfoApiResponse,
  FinancialServiceResponse,
  UserTrialsApiResponse,
  UserTrialsData,
  TrialServiceResponse,
  GrantTrialInput,
  Trial,
} from "../types/financial";
import { logger } from "../utils/logger";

export class FinancialService {
  // Get user financial information
  static async getUserFinancialInfo(
    userId: number
  ): Promise<FinancialServiceResponse> {
    try {
      const response = await ApiService.get(
        `/admin/financial/get-user-financial-info/${userId}`
      );
      const result = await ApiService.handleResponse<FinancialInfoApiResponse>(
        response
      );

      if (result.data) {
        return {
          success: true,
          data: result.data,
        };
      }

      logger.error("Unexpected financial info API response format:", result);
      return {
        success: false,
        error: "Unexpected response format",
      };
    } catch (err) {
      return failure(err, "Failed to fetch financial information");
    }
  }

  // Get user trial information
  static async getUserTrials(
    userId: number
  ): Promise<TrialServiceResponse<UserTrialsData>> {
    try {
      const response = await ApiService.get(
        `/admin/financial/users/${userId}/trials`
      );
      const result = await ApiService.handleResponse<UserTrialsApiResponse>(
        response
      );

      if (result.data) {
        return {
          success: true,
          data: result.data,
        };
      }

      return {
        success: false,
        error: "Unexpected response format",
      };
    } catch (err) {
      return failure(err, "Failed to fetch trial information");
    }
  }

  // Grant trial access to user
  static async grantTrial(
    input: GrantTrialInput
  ): Promise<TrialServiceResponse<Trial>> {
    try {
      const response = await ApiService.post("/admin/financial/trials", input);
      const result = await ApiService.handleResponse<{ data: Trial }>(response);

      if (result.data) {
        return {
          success: true,
          data: result.data,
        };
      }

      return {
        success: false,
        error: "Unexpected response format",
      };
    } catch (err) {
      return failure(err, "Failed to grant trial access");
    }
  }

  // Revoke trial access
  static async revokeTrial(trialId: number): Promise<TrialServiceResponse> {
    try {
      const response = await ApiService.delete(
        `/admin/financial/trials/${trialId}`
      );
      await ApiService.handleResponse(response);

      return {
        success: true,
      };
    } catch (err) {
      return failure(err, "Failed to revoke trial access");
    }
  }
}
